var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrush = function SvgTrush(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 1.8736H3.5C3.56875 1.8736 3.625 1.81735 3.625 1.7486V1.8736H8.375V1.7486C8.375 1.81735 8.43125 1.8736 8.5 1.8736H8.375V2.9986H9.5V1.7486C9.5 1.19703 9.05156 0.748596 8.5 0.748596H3.5C2.94844 0.748596 2.5 1.19703 2.5 1.7486V2.9986H3.625V1.8736ZM11.5 2.9986H0.5C0.223438 2.9986 0 3.22203 0 3.4986V3.9986C0 4.06735 0.05625 4.1236 0.125 4.1236H1.06875L1.45469 12.2955C1.47969 12.8283 1.92031 13.2486 2.45313 13.2486H9.54688C10.0813 13.2486 10.5203 12.8298 10.5453 12.2955L10.9313 4.1236H11.875C11.9438 4.1236 12 4.06735 12 3.9986V3.4986C12 3.22203 11.7766 2.9986 11.5 2.9986ZM9.42656 12.1236H2.57344L2.19531 4.1236H9.80469L9.42656 12.1236Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrush, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trush.56eb386f.svg";
export { ForwardRef as ReactComponent };